import { useState, useCallback, useEffect } from 'react';

const CLOSE_DURATION = 280; // ms — deve bater com a duração do slide-down

interface UseBottomSheetOptions {
  isOpen: boolean;
  onClose: () => void;
}

interface UseBottomSheetReturn {
  /** Se o DOM do modal deve estar montado */
  mounted: boolean;
  /** Classe de animação atual do sheet */
  sheetClass: string;
  /** Classe de animação atual do backdrop */
  backdropClass: string;
  /** Chama a animação de saída e depois dispara onClose */
  handleClose: () => void;
}

export function useBottomSheet({ isOpen, onClose }: UseBottomSheetOptions): UseBottomSheetReturn {
  const [mounted, setMounted] = useState(isOpen);
  const [closing, setClosing] = useState(false);

  // Quando isOpen muda para true, monta imediatamente
  useEffect(() => {
    if (isOpen) {
      setMounted(true);
      setClosing(false);
    }
  }, [isOpen]);

  const handleClose = useCallback(() => {
    setClosing(true);
    setTimeout(() => {
      setClosing(false);
      setMounted(false);
      onClose();
    }, CLOSE_DURATION);
  }, [onClose]);

  const sheetClass = closing ? 'animate-slide-down' : 'animate-slide-up';
  const backdropClass = closing ? 'animate-fade-out-backdrop' : 'animate-fade-in-backdrop';

  return { mounted, sheetClass, backdropClass, handleClose };
}
